var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0ae3da40829f8b4e5d7fae1c03c12dcb53b39d70"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@humanloop"]={id:"0ae3da40829f8b4e5d7fae1c03c12dcb53b39d70"};
      